import { InboxOutlined } from "@ant-design/icons";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

/** What a list shows before it has anything in it. */
export const EmptyState = ({
    icon = <InboxOutlined />,
    title,
    hint
}: {
    icon?: ReactNode;
    title?: ReactNode;
    hint?: ReactNode;
}) => {
    const { t } = useTranslation();

    return (
        <div className="empty-state">
            <span className="empty-state__mark">{icon}</span>
            <span className="empty-state__title">{title ?? t("list.empty")}</span>
            <span className="empty-state__hint">{hint ?? t("list.emptyHint")}</span>
        </div>
    );
};
